// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "wifi-club-affiliates.firebaseapp.com",
  "projectId": "wifi-club-affiliates",
  "storageBucket": "wifi-club-affiliates.appspot.com",
  "messagingSenderId": "919069813862",
  "appId": "1:919069813862:web:c96f04c05abdfd00e951a7",
  "measurementId": "G-H9FLWH92YL",
  "apiKey": "AIzaSyDdqmq1PR01T9tlsT7v8LFHpci0Zuj8Gu0"
};
